import JoinGamePage from './Join';

export default JoinGamePage;
